import { colorFromSeed } from "../../../shared/colors";

export const pickChatIconColor = colorFromSeed;

export function chatLabel(name: string) {
  return name === "Untitled" ? "New tab" : name;
}
